import React, { FC } from "react";

import { Switch } from "@headlessui/react";
import _ from "lodash";
import { classNames } from "utils";

type Props = {
  values: any;
  handleChange: any;
  handleBlur: any;
  setFieldValue: any;
  setFieldTouched: any;
  setFieldError: any;
  errors?: any;
  touched?: any;
  id: string;
  label: string;
  description?: string;
};

const SwitchInput: FC<Props> = ({
  values,
  handleChange,
  handleBlur,
  setFieldValue,
  setFieldTouched,
  setFieldError,
  errors,
  touched,
  id,
  label,
  description,
}) => {
  return (
    <div className="p-3 border border-gray-300 border-dashed bg-gray-100 rounded-md">
      <Switch.Group as="div">
        <span className="flex flex-grow flex-col">
          <Switch.Label
            as="span"
            className="text-sm font-medium text-gray-900"
            passive
          >
            {label}
          </Switch.Label>
        </span>
        <div className="flex items-center justify-between h-[38px]">
          <Switch.Description as="span" className="text-sm text-gray-500">
            {description}
          </Switch.Description>
          <Switch
            checked={_.get(values, id, false)}
            onChange={(val: boolean) => setFieldValue(id, val)}
            className={classNames(
              _.get(values, id, false) ? "bg-primary-600" : "bg-gray-300",
              "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            )}
          >
            <span
              aria-hidden="true"
              className={classNames(
                _.get(values, id, false) ? "translate-x-5" : "translate-x-0",
                "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
              )}
            />
          </Switch>
        </div>
      </Switch.Group>
    </div>
  );
};

export default SwitchInput;
